export const NOTIFICATION_TAB_NAMES = {
  updates: {
    key: 'updates',
    label: 'updates',
  },
  notification: {
    key: 'notification',
    label: 'notifications',
  },
};
